import { useRecoilValue } from "recoil";
import MeetWithPopup from "../../MeetWith/MeetWithPopup";
import { meetWithAccountsState } from "../../../recoil/account/accountState";
import { useState } from "react";
import { useJuneTrackCall } from "../../../utils/june/analytics";
import styles from "./header.module.css";
import { MeetWithColors } from "../../../constants";
import { Popover } from "radix-ui";

const MeetWithButton = () => {
  const meetWithAccounts = useRecoilValue(meetWithAccountsState);
  const trackCall = useJuneTrackCall();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (isOpen: boolean) => {
    setIsOpen(isOpen);
  };

  return (
    <Popover.Root
      open={isOpen}
      onOpenChange={handleOpenChange}
    >
      <Popover.Trigger asChild>
        <button
          className={`${styles.meetWithButton} ${isOpen && styles.meetWithActive}`}
          onClick={() => {
            trackCall("click_meet_with");
            setIsOpen(!isOpen);
          }}
        >
          {meetWithAccounts.length > 0 ? (
            <div className={styles.meetWithBadgeWrapper}>
              <span> +{meetWithAccounts.length}</span>
              <span className={styles.meetWithBadge}>
                {meetWithAccounts.map((account, idx) =>
                  idx < 5 ? (
                    <span
                      key={`meetWithButton_${account.email}`}
                      style={{
                        backgroundColor: MeetWithColors[idx % MeetWithColors.length],
                      }}
                    ></span>
                  ) : (
                    idx === 5 && (
                      <span
                        key="badgeMore"
                        className={styles.badgeMore}
                      ></span>
                    )
                  )
                )}
              </span>
            </div>
          ) : (
            "Meet"
          )}
        </button>
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content
          align="end"
          sideOffset={5}
          onCloseAutoFocus={(e) => {
            e.preventDefault();
          }}
        >
          <MeetWithPopup />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export default MeetWithButton;
